export default __webpack_public_path__ + "static/media/newwebsite.e0eded8e.jpg";